class EventBus {
    constructor() {
        this.events = {};
    }
    on(event, listener) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }
    off(event, listener) {
        if (!this.events[event]) return;
        this.events[event] = this.events[event].filter(l => l !== listener);
    }
    emit(event, data) {
        if (!this.events[event]) return;
        this.events[event].forEach(listener => listener(data));
    }
}
class CartManager {
    constructor(schema, eventBus) {
        this.schema = schema; // Promotion schema
        this.cartState = {}; // Current cart state
        this.eventBus = eventBus; // Event bus for communication
    }
    _handleWorkerMessage(event) {
        const cartData = event.data; // Update the data with the worker's response
        this.cartState = cartData;
    }
    async fetchCartData() {
        return await fetch('/cart.js').then(response => response.json());
    }

    // Update cart state and notify subscribers
    updateCartState(newCartState) {
        this.cartState = newCartState;
        this.eventBus.emit('cart:updated', this.cartState);
    }

    // Get the total cart value excluding gifts
    getCartTotal() {
        if (!this.cartState.items) return 0;

        const giftVariantIds = this.getGiftVariantIds();

        return this.cartState.items
            .filter(item => !giftVariantIds.includes(item.variant_id))
            .reduce((total, item) => total + item.line_price, 0) / 100;
    }

    // Get all gift variant IDs from the schema
    getGiftVariantIds() {
        return Object.values(this.schema).flatMap(item => item.variant_id);
    }

    // Check if a gift exists in the cart
    hasGiftInCart(code = '') {
        if (!this.cartState.items) return false;

        const giftVariantIds = this.getGiftVariantIds();
        return this.cartState.items.some(item => {
            const isGift = giftVariantIds.includes(item.variant_id);
            const isMatchingCode = code === '' || this.schema[code]?.variant_id === item.variant_id;
            return isGift && isMatchingCode;
        });
    }
    // Claim the discount code based on the cart total
    claimDiscountCode() {
        const cartTotal = this.getCartTotal();
        let code = '';
        Object.entries(this.schema).forEach(([key, value]) => {
            if (cartTotal >= value.threshold) {
                code = key;
            }
        });
        return code;
    }
    async updateCartSwitchGift(code, variant_id) {
        if (this.cartState == null) {
            this.cartState = await this.fetchCartData();
        }
        var items = repairCartItems(this.cartState, variant_id, this.schema);
        return await updateCartEndpoint({ updates: items, discount: code });
    }
}
const extractItems = function (cart_data) {
    var data = {}
    var line_items = cart_data.items
    if (line_items.length == 0) return;
    line_items.forEach(function (item) {
        let variant_id = item.variant_id
        let quantity = item.quantity
        data[variant_id] = quantity
    })
    return data;
}
const getListGifts = function (schema) {
    return Object.values(schema).flatMap(item => item.variant_id);
}
const repairCartItems = function (cart_data, variant_id, schema) {
    let items = extractItems(cart_data);
    const giftVariantIds = getListGifts(schema);
    let sub_variant_ids = [];

    if (Array.isArray(variant_id)) {
        sub_variant_ids = variant_id;
    } else {
        sub_variant_ids.push(variant_id);
    }

    // loop through items and add ids of gifts with quantity 0
    giftVariantIds.forEach(function (id) {
        items[id] = 0;
    });
    sub_variant_ids.forEach(function (id) {
        items[id] = 1;
    });
    return items;
}

const updateCartEndpoint = async function (data) {
    return await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

const getGiftByCode = function (schema, code) {
    return schema[code] ?? null;
}

const existCacheDiscount = function () {
    const cachedDiscounts = sessionStorage.getItem("discountTickets");
    return cachedDiscounts ? true : false;
}

const isValidAmount = function (cartTotal, schema, code) {
    const giftInfo = getGiftByCode(schema, code);
    if (!giftInfo) return false;
    return cartTotal >= giftInfo.threshold;
}

const addAnimationToDropdownIcon = function (count = 1) {
    const isReadyDom = setInterval(() => {
        const dropdownIcon = document.getElementById('dropdown-discount-btn')
        if (dropdownIcon) {
            clearInterval(isReadyDom);
            if (count == 3) {
                dropdownIcon.classList.add('animate-dropdown-icon-noinfinite');
                setTimeout(() => {
                    dropdownIcon.classList.remove('animate-dropdown-icon-noinfinite');
                    dropdownIcon.classList.add('animate-dropdown-icon');
                }, 3000);
                return;
            }
            dropdownIcon.classList.add('animate-dropdown-icon');
        }
    }, 500);
}

document.addEventListener("DOMContentLoaded", function () {
    const schema = window.guide_campaign_dropdown_items || {};

    if (schema == null || Object.keys(schema).length === 0) {
        // hide voucher dropdown button
        const dropdownButton = document.getElementById('dropdown-discount-btn');
        let isReadyDom = setInterval(() => {
            if (dropdownButton) {
                clearInterval(isReadyDom);
                dropdownButton.style.display = 'none';
            }
        }, 500);
        return;
    }

    const eventBus = new EventBus();

    const cartManager = new CartManager(schema, eventBus);
    let countGuide = 0;
    let maxGuide = 3;

    const robotGuideDiscount = function () {

        if (countGuide >= maxGuide) {
            // add animation icon
            addAnimationToDropdownIcon();
            return;
        }

        if (!existCacheDiscount()) {
            setTimeout(robotGuideDiscount, 1000);
            return;
        }

        const claimCode = cartManager.claimDiscountCode();
        if (!claimCode || cartManager.hasGiftInCart(claimCode)) return;

        setTimeout(() => {
            eventBus.emit('dropdown:open');
        }, 1000);
    };

    document.addEventListener('cart:change', function (event) {
        const newCartState = event.detail.cart;
        cartManager.updateCartState(newCartState);
        const store = window.discountStore;
        if (store) {
            store.update({ status: 'idle', message: '' });
        }
    });

    document.addEventListener('discount:change', function (event) {
        let discount_code = event.detail?.code?.trim().toUpperCase();
        // if(existGiftInCart(schema,discount_code)){
        //     eventBus.emit('discount:note:fail', {
        //         message: "Item hadiah sudah ada di keranjang, <br>hapus item hadiah yang ada untuk menerapkan diskon baru."
        //     });
        //     eventBus.emit('clear:discount');
        //     return;
        // }

        if (isValidAmount(cartManager.getCartTotal(), schema, discount_code) === false) {
            eventBus.emit('discount:note:fail', {
                message: `Total belanja tidak memenuhi jumlah yang diperlukan untuk kode diskon ${discount_code}.`
            });
            eventBus.emit('clear:discount');
            return;
        }

        let { variant_id, quantity } = getGiftByCode(schema, discount_code) || {};
        if (!variant_id) return;


        const store = window.discountStore;
        if (store) {
            store.update({ status: 'loading', message: '' });
        }

        cartManager.updateCartSwitchGift(discount_code, variant_id).then((res) => {
            eventBus.emit('discount:apply', res);
            countGuide++;
        });
    });

    eventBus.on('dropdown:open', function () {
        const waitTime = 500;
        let isButtonReady = setInterval(() => {
            const button_dropdown = document.getElementById('dropdown-discount-btn');
            if (button_dropdown) {
                clearInterval(isButtonReady);
                button_dropdown.click();
                eventBus.emit('click:ticket:code');
            } else {
                console.log('Waiting for dropdown button DOM...');
            }
        }, waitTime);

    });

    eventBus.on('click:ticket:code', function () {
        const claimCode = cartManager.claimDiscountCode();
        if (!claimCode) return;
        const waitTime = 1000;

        let isDomReady = setInterval(() => {
            const discountTicketList = document.querySelector('discount-ticket-list');
            if (discountTicketList) {
                clearInterval(isDomReady);
                discountTicketList.querySelectorAll('.ticket__code').forEach(el => {
                    const code = el.getAttribute('data-discount-code');
                    if (code === claimCode) {
                        setTimeout(() => el.click(), waitTime);
                    }
                });
            } else {
                console.log('Waiting for discount-ticket-list DOM...');
            }
        }, 1000);
    });

    eventBus.on('discount:apply', function (event) {

        // read message from event and show success message in discount-note 
        const discount_note = document.querySelector('discount-note');
        if (!discount_note) return;
        const message = event?.message || 'Hadiah berhasil ditambahkan ke keranjang.';

        const store = window.discountStore;
        if (store) {
            store.update({ status: 'success', message });
        }

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        if (countGuide >= maxGuide) {
            // add animation icon
            setTimeout(() => {
                addAnimationToDropdownIcon(countGuide);
                countGuide++;
            }, 1500)
        }
    });

    eventBus.on('discount:note:fail', function (data) {
        const discount_note = document.querySelector('discount-note');
        if (!discount_note) return;
        discount_note.dispatchEvent(new CustomEvent('discount:note:fail', { detail: data }));
    });

    eventBus.on('clear:discount', function () {
        const discount_input = document.getElementById('discount-code')
        if (!discount_input) return;
        discount_input.value = '';
        discount_input.dispatchEvent(new Event('input', { bubbles: true }));
        // save discount code to session storage

    });

    // Listen for cart updates
    eventBus.on('cart:updated', robotGuideDiscount);

});